import React, { useState, useEffect } from 'react'
import bg from '../../images/aspirationBanner.webp'
import { useMediaQuery } from 'react-responsive';
import ContactModal from './ContactModal';
import { setToggleTrue } from '../../redux/slice/changeState'
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-scroll';
import { Row, Col } from 'react-bootstrap';

const Banner = () => {
    const isTablet = useMediaQuery({ query: '(min-width: 992px) and (max-width: 1104px)' });
    const dispatch = useDispatch()
    const toggle = useSelector((state) => state.toggle);
    const [navSolid, setNavSolid] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 75) {
            setNavSolid(true);
        } else {
            setNavSolid(false);
        }
    }
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (
        <>
            <div className='banner position-relative'>
                <img src="/aspiration.png" className='img-fluid w-100' alt="aspiration"></img>
                <div className='position-absolute banner-title'>
                    <img src="/IRA-White1.png" className='' alt="aspiration"></img>
                    <img src="/Aspiration.png" className='' alt="aspiration"></img>
                </div>
                <div className='position-absolute banner-discption'>
                    {isTablet ?
                        <h1 className='m-50'>Ready-to-Move In Luxury 2&3 BHK Apartments In Kollur Starting At ₹1.20 Cr.</h1>
                        :
                        <>
                            <h1 className=''>Ready-to-Move In Luxury 2&3 BHK</h1>
                            <h1 className='m-50'>Apartments In Kollur Starting At ₹1.20 Cr</h1>
                        </>
                    }
                    <p className='mb-4'>Find Your Future Home Today</p>
                    <div>
                        <button className='visit-btn' onClick={() => dispatch(setToggleTrue())}>Book a Visit</button>
                        <button className='explore-btn'><a href='https://wa.api-whatsapp.in/ehbv4C' target="_blank" rel="noreferrer">Chat on Whatsapp</a></button>
                    </div>

                    <div className='container mt-5 ' style={{
                        maxWidth:"800px"
                    }}>
                        <Row className='border border-white'>
                            <Col lg={6} md={6} xs={12} className='border-end ps-3 py-2'>
                                <p className="small-text">Layout/Building/Permission No.</p>
                                <p className='large-text'>File No. 036703/SKP/R1/U6/HMDA/19062020</p>
                            </Col>

                            <Col lg={6} md={6} xs={12} className='ps-3  py-2'>
                                <p className='large-text'>
                                    TG RERA Registration No. <span>P01100002880</span>
                                </p>
                                <p className="small-text">
                                    Website: <a
                                        href="https://rera.telangana.gov.in"
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                            textDecoration: "none",
                                            color: "#fff",
                                            cursor: "pointer",
                                        }}
                                    >
                                        rera.telangana.gov.in
                                    </a>
                                </p>
                            </Col>


                        </Row>


                    </div>
                </div>
                <ul className='position-absolute'>
                    <li><a href="/">Overview</a></li>
                    <li><Link to="amenities" smooth={true} duration={1000}>Amenities</Link></li>
                    <li><Link to="facing" smooth={true} duration={1000}>Floor Plans</Link></li>
                    <li><Link to="pricing-section" smooth={true} duration={1000}>Pricing & Availability</Link></li>
                    <li><Link to="location" smooth={true} duration={1000}>Location</Link></li>
                    <li><a onClick={() => dispatch(setToggleTrue())}>Contact</a></li>
                </ul>
            </div>
            {
                toggle.hastoggle && <ContactModal />
            }
        </>
    )
}

export default Banner
